import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a0773fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "staff-auth" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-title" }, "基本信息", -1))
const _hoisted_3 = { class: "uf-form-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, [
  /*#__PURE__*/_createTextVNode(" 姓名 "),
  /*#__PURE__*/_createElementVNode("i", null, "*")
], -1))
const _hoisted_5 = { class: "uf-form-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, " 性别 ", -1))
const _hoisted_7 = { class: "uf-form-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, [
  /*#__PURE__*/_createTextVNode(" 手机号 "),
  /*#__PURE__*/_createElementVNode("i", null, "*")
], -1))
const _hoisted_9 = { class: "uf-form-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, " 邮箱 ", -1))
const _hoisted_11 = { class: "uf-form-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, " 身份证照片 ", -1))
const _hoisted_13 = { class: "uf-form-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, " 身份证号 ", -1))
const _hoisted_15 = { class: "uf-form-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, " 身份证有效期 ", -1))
const _hoisted_17 = { class: "title" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "uf-form-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, " 证件类型 ", -1))
const _hoisted_21 = {
  key: 0,
  class: "uf-form-item"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, [
  /*#__PURE__*/_createTextVNode(" 证件名称 "),
  /*#__PURE__*/_createElementVNode("i", null, "*")
], -1))
const _hoisted_23 = {
  key: 1,
  class: "uf-form-item"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, " 上传证件 ", -1))
const _hoisted_25 = { class: "uf-form-item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-title" }, "供应商信息", -1))
const _hoisted_27 = { class: "uf-form-item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, [
  /*#__PURE__*/_createTextVNode(" 供应商名称 "),
  /*#__PURE__*/_createElementVNode("i", null, "*")
], -1))
const _hoisted_29 = { class: "uf-form-item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, " 营业执照 ", -1))
const _hoisted_31 = { class: "uf-form-item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, " 统一社会信用代码 ", -1))
const _hoisted_33 = { class: "uf-form-item" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, " 营业期限 ", -1))
const _hoisted_35 = { class: "uf-form-item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, " 联系地址 ", -1))
const _hoisted_37 = { class: "uf-form-item" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, " 联系人 ", -1))
const _hoisted_39 = { class: "uf-form-item" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, " 联系电话 ", -1))
const _hoisted_41 = { class: "uf-button" }
const _hoisted_42 = { class: "uf-button--footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_uf_idcard_upload = _resolveComponent("uf-idcard-upload")!
  const _component_uf_daterange_picker = _resolveComponent("uf-daterange-picker")!
  const _component_uf_upload = _resolveComponent("uf-upload")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_divider = _resolveComponent("van-divider")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_uf_region = _resolveComponent("uf-region")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_form, {
      onSubmit: _ctx.onSubmit,
      onFailed: _ctx.onFailed,
      class: "uf-form",
      "show-error": "",
      "scroll-to-error": "",
      "show-error-message": false
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_van_field, {
            modelValue: _ctx.formData.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
            name: "name",
            placeholder: "请输入",
            maxlength: "20",
            rules: [{ required: true, message: '请填写姓名' }]
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_van_field, {
            modelValue: _ctx.genderPicker.label,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.genderPicker.label) = $event)),
            readonly: "",
            clickable: "",
            placeholder: "请选择",
            "right-icon": "arrow",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.genderPicker.showPicker = true))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_van_field, {
            modelValue: _ctx.formData.mobile,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.mobile) = $event)),
            name: "mobile",
            placeholder: "请输入",
            rules: [
            { required: true, message: '请填写手机号' },
            { pattern: _ctx.validate.mobile.reg, message: _ctx.validate.mobile.msg }
          ]
          }, null, 8, ["modelValue", "rules"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_van_field, {
            modelValue: _ctx.formData.email,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.email) = $event)),
            name: "email",
            placeholder: "请输入",
            rules: [
            {
              validator(value) {
                if (!value) return true;
                return _ctx.validate.test('email', value);
              },
              message: _ctx.validate.email.msg
            }
          ]
          }, null, 8, ["modelValue", "rules"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_van_field, null, {
            input: _withCtx(() => [
              _createVNode(_component_uf_idcard_upload, {
                modelValue: _ctx.idcardData,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.idcardData) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_van_field, {
            modelValue: _ctx.formData.id_card,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.id_card) = $event)),
            name: "id_card",
            placeholder: "请输入",
            rules: [
            {
              validator(value) {
                if (!value) return true;
                return _ctx.validate.isCardID(value);
              },
              message: '请输入正确的身份证号'
            }
          ]
          }, null, 8, ["modelValue", "rules"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(_component_van_field, {
            modelValue: _ctx.validityOfIDCard.label,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.validityOfIDCard.label) = $event)),
            readonly: "",
            clickable: "",
            placeholder: "请选择",
            "right-icon": "arrow",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.daterangePickerIsShow = true))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_uf_daterange_picker, {
            show: _ctx.daterangePickerIsShow,
            "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.daterangePickerIsShow) = $event)),
            modelValue: _ctx.daterangePickerData,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.daterangePickerData) = $event))
          }, null, 8, ["show", "modelValue"])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificates, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "certificate",
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_17, [
              _createTextVNode(" 资格证" + _toDisplayString(index + 1) + " ", 1),
              (index !== 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "delete",
                    onClick: ($event: any) => (_ctx.removeCertificate(index))
                  }, " 删除 ", 8, _hoisted_18))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_van_field, {
                modelValue: item.certificateTypePicker.label,
                "onUpdate:modelValue": ($event: any) => ((item.certificateTypePicker.label) = $event),
                readonly: "",
                clickable: "",
                placeholder: "请选择",
                "right-icon": "arrow",
                onClick: ($event: any) => (item.certificateTypePicker.showPicker = true)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"])
            ]),
            (item.certificateTypePicker.value === '5')
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode(_component_van_field, {
                    modelValue: item.certificateName,
                    "onUpdate:modelValue": ($event: any) => ((item.certificateName) = $event),
                    placeholder: "请输入",
                    rules: [{ required: true, message: '请填写证件名称' }]
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]))
              : _createCommentVNode("", true),
            (item.certificateTypePicker.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _hoisted_24,
                  _createVNode(_component_van_field, null, {
                    input: _withCtx(() => [
                      _createVNode(_component_uf_upload, {
                        modelValue: item.certificateFile,
                        "onUpdate:modelValue": ($event: any) => ((item.certificateFile) = $event),
                        "max-count": "1",
                        "tip-text": "支持扩展名：.png .jpg .pdf，单个文件大小不超过10M",
                        "max-size": 20 * 1024 * 1024
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_van_popup, {
              show: item.certificateTypePicker.showPicker,
              "onUpdate:show": ($event: any) => ((item.certificateTypePicker.showPicker) = $event),
              position: "bottom",
              "safe-area-inset-bottom": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_picker, {
                  title: "证件类型",
                  columns: item.certificateTypePicker.columns,
                  onConfirm: item.certificateTypePicker.onConfirm,
                  onCancel: item.certificateTypePicker.onCancel,
                  onChange: item.certificateTypePicker.onChange
                }, null, 8, ["columns", "onConfirm", "onCancel", "onChange"])
              ]),
              _: 2
            }, 1032, ["show", "onUpdate:show"]),
            (index !== _ctx.certificates.length - 1)
              ? (_openBlock(), _createBlock(_component_van_divider, {
                  key: 2,
                  style: { margin: '0', padding: '0 15px' }
                }))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", {
            class: "add-certificate",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.addCertificate && _ctx.addCertificate(...args)))
          }, [
            _createVNode(_component_van_icon, {
              name: "plus",
              style: {"margin-right":"5px"}
            }),
            _createTextVNode(" 新增 ")
          ])
        ]),
        _hoisted_26,
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createVNode(_component_van_field, {
            modelValue: _ctx.formData.factory_name,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.factory_name) = $event)),
            name: "factory_name",
            placeholder: "请输入",
            rules: [{ required: true, message: '请填写供应商名称' }]
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createVNode(_component_van_field, null, {
            input: _withCtx(() => [
              _createVNode(_component_uf_upload, {
                modelValue: _ctx.licenseFile,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.licenseFile) = $event)),
                "max-count": "1",
                "tip-text": "支持扩展名：.png .jpg .pdf，单个文件大小不超过10M",
                "max-size": 20 * 1024 * 1024
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createVNode(_component_van_field, {
            modelValue: _ctx.formData.social_credit,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.social_credit) = $event)),
            name: "social_credit",
            placeholder: "请输入",
            rules: [
            {
              validator(value) {
                if (!value) return true;
                return _ctx.validate.test('creditCode', value);
              },
              message: _ctx.validate.creditCode.msg
            }
          ]
          }, null, 8, ["modelValue", "rules"])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createVNode(_component_van_field, {
            modelValue: _ctx.validityOfFactory.label,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.validityOfFactory.label) = $event)),
            readonly: "",
            clickable: "",
            placeholder: "请选择",
            "right-icon": "arrow",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.daterangePicker2IsShow = true))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_uf_daterange_picker, {
            show: _ctx.daterangePicker2IsShow,
            "onUpdate:show": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.daterangePicker2IsShow) = $event)),
            modelValue: _ctx.daterangePicker2Data,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.daterangePicker2Data) = $event))
          }, null, 8, ["show", "modelValue"])
        ]),
        _createVNode(_component_uf_region, {
          modelValue: _ctx.area,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.area) = $event)),
          options: {
          title: '公司所在地',
          is_checked: '2',
          power: '2'
        }
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createVNode(_component_van_field, {
            modelValue: _ctx.formData.address,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.address) = $event)),
            name: "address",
            placeholder: "请输入"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createVNode(_component_van_field, {
            modelValue: _ctx.formData.contact_name,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.contact_name) = $event)),
            name: "contact_name",
            placeholder: "请输入"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _hoisted_40,
          _createVNode(_component_van_field, {
            modelValue: _ctx.formData.contact_phone,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.contact_phone) = $event)),
            name: "contact_phone",
            placeholder: "请输入",
            rules: [
            {
              validator(value) {
                if (!value) return true;
                return _ctx.validate.test('mobile', value);
              },
              message: _ctx.validate.mobile.msg
            }
          ]
          }, null, 8, ["modelValue", "rules"])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createVNode(_component_van_button, {
              class: "btn",
              block: "",
              color: "#3d6eeb",
              square: "",
              type: "success",
              "native-type": "submit"
            }, {
              default: _withCtx(() => [
                _createTextVNode("提交认证申请 ")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "onFailed"]),
    _createVNode(_component_van_popup, {
      show: _ctx.genderPicker.showPicker,
      "onUpdate:show": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.genderPicker.showPicker) = $event)),
      position: "bottom",
      "safe-area-inset-bottom": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "性别选择",
          columns: _ctx.genderPicker.columns,
          onConfirm: _ctx.genderPicker.onConfirm,
          onCancel: _ctx.genderPicker.onCancel,
          onChange: _ctx.genderPicker.onChange
        }, null, 8, ["columns", "onConfirm", "onCancel", "onChange"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}